import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useTerminationLastVestingDate = () => {
  const {
    mutate: calcTerminationLastVestingDate,
    isPending,
    data,
  } = useAppMutation<
    Date,
    HttpException,
    { companyId: string; data: { terminationDate: string; vestingTaskIds: string[] } }
  >([QueryKey.CALC_LAST_VESTING_DATE], {
    mutationFn: ({ companyId, data }: { companyId: string; data: { terminationDate: string } }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', 'termination-last-vesting-date'],
        },
        { body: data },
      ),
  });

  return { calcTerminationLastVestingDate, isPending, data };
};
